<template>
    <div>
        <div v-if="voucher">
            <span class="ssv-summry-voucher-box__code">Kód slevového poukazu: {{voucher.code}}</span>
            <span class="float--left ssv-summry-voucher-box__sale">sleva {{saleFormat()}}</span>
            <button class="button button--link" v-on:click="removeVoucher()">Odebrat</button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'SsvOrderVoucherInformation',
        computed: {
            ...mapGetters('ssvOrder', ['voucher']),
        },
        methods: {
            ...mapActions('ssvOrder', ['removeVoucher']),
            saleFormat() {
                const {percentageDiscount, priceDiscount} = this.voucher;
                if (percentageDiscount) return `${percentageDiscount}%`
                else if (priceDiscount) return `${priceDiscount} Kč`
                return null;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/voucher/VoucherInformation.vue